import * as Library from "../../../../utils/Library";
export const MANUAL_REPORT_CONTRACT = "manual-report/v1";
// QueryClient survives route/logout navigation. An opaque epoch prevents a later
// account in the same company reusing an earlier account's cached report. The
// existing token is compared in memory only; it never enters a key or report.
let observedToken, accountEpoch = 0;
const accountCacheScope = () => {
    const token = localStorage.getItem("token");
    if (token !== observedToken) { observedToken = token; accountEpoch++; }
    return accountEpoch;
};
export const manualReportKey = row => ["ManualCheckReport", accountCacheScope(), localStorage.getItem("currentCompanyID"), row?._id, row?.retailBrandID, row?.storeID, row?.updatedAt];
export const manualReportContext = row => ({ scopeKind: "order-check/v2", orderID: row?._id, retailBrandID: row?.retailBrandID,
    storeID: row?.storeID, expectedUpdatedAt: row?.updatedAt, supplierOrderType: row?.supplierOrderType, reportContract: MANUAL_REPORT_CONTRACT });
export async function readManualReport(row, summary = false) {
    const response = await Library.makeApiRequest({ endpoint: "X/SupplierOrders/checkSupplierOrderPrices", onErrorShowMsg: false,
        data: { supplierOrderID: row._id, retailBrandID: row.retailBrandID, storeID: row.storeID, expectedUpdatedAt: row.updatedAt,
            scopeKind: "order-check/v2", reportContract: MANUAL_REPORT_CONTRACT, checkAction: summary ? "summary" : "report" } });
    const report = response?.data?.status === 200 ? response.data.data?.manualReport : null;
    const failedState = ["error", "uncertain"].includes(report?.state);
    const hasSaved = report?.available === true;
    const stateConsistent = report?.state === "empty" ? report.generation === 0 && !report.available
        : Number.isSafeInteger(report?.generation) && report.generation >= 1;
    if (report?.contract !== MANUAL_REPORT_CONTRACT || typeof report.available !== "boolean" ||
        !["empty", "running", "saved", "cancelled", "error", "uncertain"].includes(report.state) ||
        !Number.isSafeInteger(report.generation) || report.generation < 0 ||
        !stateConsistent ||
        (failedState ? typeof report.error !== "string" || !/^[A-Z][A-Z0-9_]{0,95}$/.test(report.error) : report.error != null) ||
        (report.state === "saved" && !report.available) || (report.state === "cancelled" && report.available) ||
        (!report.available && (report.count != null || report.review != null)) ||
        (hasSaved ? !Number.isSafeInteger(report.count) || report.count < 0 : report.count != null))
        throw Error("Saved CHECK status unavailable; no CHECK started.");
    if (report.available && !summary) savedReportReview(report, manualReportContext(row));
    return report;
}
export function manualCardCount(report) {
    if (!report) return "—";
    if (report.available && Number.isSafeInteger(report.count) && report.count >= 0) return report.count;
    if (report.error || ["error", "uncertain"].includes(report.state)) return "error";
    return "—";
}
// Preserve last verified saved evidence while the separate attempt is pending/failed.
export function retainSavedReport(previous, attempt) {
    if (!previous?.available || !Number.isSafeInteger(previous.count) || previous.count < 0 ||
        attempt?.state === "saved" && !attempt.error && attempt.available && Number.isSafeInteger(attempt.count) && attempt.count >= 0) return attempt;
    return { ...previous, ...attempt, available: true, savedState: "saved", count: previous.count, review: previous.review,
        savedAt: previous.savedAt, sourceRevision: previous.sourceRevision, qualification: previous.qualification };
}
export function savedReportReview(report, context, selectionSummary, posDisplay) {
    if (!report.available || report.review?.kind !== "order-differences" || !["partial", "complete"].includes(report.review.status) ||
        !Array.isArray(report.review.products) || !report.review.coverage ||
        ![report.review.coverage.requested, report.review.coverage.existing, report.review.coverage.unknown].every(n => Number.isSafeInteger(n) && n >= 0) ||
        report.review.products.some(p => !p || typeof p.productID !== "string" || !Array.isArray(p.fields) || !Array.isArray(p.gtins)) ||
        report.review.context?.orderID !== context.orderID ||
        report.review.context?.storeID !== context.storeID || report.review.context?.retailBrandID !== context.retailBrandID)
        throw Error("Saved CHECK report unavailable; no CHECK started.");
    return { ...report.review, processing: false, context, selectionSummary, posDisplay: report.review.posDisplay || posDisplay, manualReport: report };
}
